import { AppRouter } from './pages/Router';
import { Toaster } from './components/ui/toast';
import './index.css';

function App() {
  return (
    <>
      <AppRouter />
      <Toaster />
    </>
  );
}

export default App
